import { Box, List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TalentLink } from "../editOrder/long/talentsStatus/TalentLink";
import { CandidateGroupItem } from "../types/editOrder";

type Props = {
  selectedTalents: CandidateGroupItem[];
};

const ChooseForInterviewDialogContent = ({ selectedTalents }: Props) => {
  const { t } = useTranslation("order");

  const contentText =
    selectedTalents.length > 1
      ? t("candidatesForIntrerviewPlural")
      : t("candidatesForIntrerviewSingular");

  return (
    <Box>
      <Box>{contentText}</Box>
      <List>
        {selectedTalents.map((talent) => (
          <ListItem key={talent.id} disablePadding>
            <ListItemText
              primary={
                <TalentLink id={talent.id} name={talent.fullName} status={talent.status} openInNewTab />
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ChooseForInterviewDialogContent;
